<!--
    file type .....: HTML file: approverequest.component.html
    Created By ....: ianday
    Date ..........: 10/23/23 
-->
<div class="approverequest-container">

    <div class="local-top-section">
        <div class="dwform">
            <div class="dwform-row-gap-half"></div>
            <label class="label-field">Case Information:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.caseNumber}} - {{this.fullName}}</label>

            <!-- Request Type --->
            <div class="dwform-row-gap"></div>

            <label class="label-field">Request Type:</label>
            <span class="form-required"> </span>
            <label class="label-field-data">{{this.serviceRequestType}}</label>

            <!-- Service Range --->
            <div class="dwform-row-gap"></div>
            <label class="label-field">Service Range:</label>
            <span class="form-required"> </span>
            <div style="display:inline-block" *ngIf="startDate !== null">
            <label class="label-field-data">{{this.startDate}} To: {{this.endDate}}</label>
            </div>
        </div>
    </div>

    <div class="dwform-row-gap"></div>
    <mat-divider></mat-divider>

    <div class="local-mid-section">
        <div class="dwform">
        <!-- Amount requested: -->
        <div class="dwform-row-gap-half"></div>

        <label class="label-field">Requested:</label>
        <span class="form-required"> </span>

        <div tabindex="-1"
             style="display: inline-block; height: 30px"
             class="input-field-shortest input-no-border" >{{lblDecimal(requested)}}</div>
            <label class="label-field" style="width:180px">{{unitOfMeasure}}</label>

        <!-- Already Provided: -->
        <div class="dwform-row-gap-half"></div>

        <label class="label-field">Already Provided:</label>
        <span class="form-required"> </span>

        <div tabindex="-1"
             style="display: inline-block; height: 30px"
             class="input-field-shortest input-no-border" >{{lblDecimal(alreadyProvided)}}</div>
            <label class="label-field" style="width:180px">{{unitOfMeasure}}</label>
        <!-- Remaining: -->
        <div class="dwform-row-gap-half"></div>

        <label class="label-field">Remaining:</label>
        <span class="form-required"> </span>

        <div tabindex="-1"
             style="display: inline-block; height: 30px"
             class="input-field-shortest input-no-border" >{{lblDecimal(remaining)}}</div>
        <label class="label-field" style="width:180px">{{unitOfMeasure}}</label>

        <div class="dwform-row-gap-half"></div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <div class="dwform-row-gap-half"></div>

    <span style="font-weight: bold;"> Agency Responses: </span>

    <div class="dwform-row-gap-half"></div>
    <div class="mat-elevation-z2 control-strip" >
        <TABLE style="padding-top:2px;width: 100%"> <TR style="width:100%;">
            <TD>
                <button  mat-button *ngIf="visibleAdd"
                        class="command-button command-button-override"
                        matTooltipPosition="above"
                        matTooltip="Add a new contribution" (click)="doAddNewContribution()"
                        mat-button>
                    <mat-icon class="command-icon-style">add_circle_outline</mat-icon>
                    Add
                </button>

                <button *ngIf="visibleCollaborate" mat-button
                        class="command-button command-button-override"
                        matTooltipPosition="right"
                        matTooltip="Request a collaboration" (click)="doCollaborate()"
                        mat-button>
                    <mat-icon class="command-icon-style">share_outline</mat-icon>
                    Collaborate
                </button>
            </TD>
        </TR>
        </TABLE>
    </div>

    <!-- CONTRIBUTIONS TABLE -->
    <div #contribTable class="table-container mat-elevation-z1" id="contributionsTableId"
         (keydown)="tableKeyDown($event)" tabindex="-1">
        <table mat-table [dataSource]="dataSource" style="width:100%;">

            <!-- Position Column [THIS IS HIDDEN ]-->
            <ng-container matColumnDef="id" >
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local" [hidden]="true"
                    style="min-width: 50px;">Id
                </th>
                <td mat-cell style="width:50px!important;" [hidden]="true"
                    class="table-detail-style-local"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.id}}</td>
            </ng-container>

            <!-- Operation-->
            <ng-container matColumnDef="operation" >
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local" [hidden]="true"
                    style="min-width: 50px;">
                </th>
                <td mat-cell style="width:50px!important;" [hidden]="true"
                    class="table-detail-style-local"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.operation}}</td>
            </ng-container>


            <!-- Agency Name -->
            <ng-container matColumnDef="agencyName" >
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local"
                    style="min-width: 260px;padding-left: 3px;">Agency Name
                </th>
                <td mat-cell style="width: 260px!important; padding-left: 3px;"
                    class="table-detail-style-local"
                    *matCellDef="let element">{{getAgencyName(element.agencyId)}}</td>
            </ng-container>

            <!-- Commitment -->
            <ng-container matColumnDef="plannedCommitted" *ngIf="primaryAgencyFlag">
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local"
                    style="min-width: 150px;">Commitment Status
                </th>
                <td mat-cell style="width:170px!important;"
                    class="table-detail-style-local"
                    *matCellDef="let element">
                    <dw-dropdown
                            *ngIf="editSelfCollaborateResponses && selectedRecord?.agencyId == myAgencyId && (selectedRecord?.id === element.id)"
                            [selectedItem]="element.plannedCommitted"
                            (change)="doStatusChange(selectedRecord.id, element)"
                            (itemSelected)="element.plannedCommitted = $event;
                                doStatusChange(selectedRecord.id, element)"
                            [dataSource]="givingOptionsList">
                    </dw-dropdown>
                    <dw-dropdown
                            *ngIf="editOtherCollaborateResponses && selectedRecord?.agencyId !== myAgencyId && (selectedRecord?.id === element.id)"
                            [selectedItem]="element.plannedCommitted"
                            (change)="doStatusChange(selectedRecord.id, element)"
                            (itemSelected)="element.plannedCommitted = $event;
                                doStatusChange(selectedRecord.id, element)"
                            [dataSource]="givingOptionsList">
                    </dw-dropdown>

                    <span *ngIf="!editOtherCollaborateResponses && selectedRecord?.agencyId !== myAgencyId && (selectedRecord?.id === element.id)"
                          [ngStyle]="{'color': showCommitmentColors(element.plannedCommitted)}"
                          style="padding-left: 3px;">{{element.plannedCommitted}}</span>
                    <span *ngIf="!editSelfCollaborateResponses && selectedRecord?.agencyId !== myAgencyId && (selectedRecord?.id === element.id)"
                          [ngStyle]="{'color': showCommitmentColors(element.plannedCommitted)}"
                          style="padding-left: 3px;">{{element.plannedCommitted}}</span>
                      <span *ngIf="selectedRecord?.id !== element.id"
                          [ngStyle]="{'color': showCommitmentColors(element.plannedCommitted)}"
                          style="padding-left: 3px;">{{element.plannedCommitted}}</span>
                </td>
            </ng-container>
                <!-- Commitment -->
          <ng-container matColumnDef="plannedCommitted" *ngIf="!primaryAgencyFlag">

                    <th mat-header-cell *matHeaderCellDef
                        class="table-header-style-local"
                        style="min-width: 150px;">
                        Commitment Status
                    </th>

                    <td mat-cell
                        class="table-detail-style-local"
                        style="width:170px!important;"
                        *matCellDef="let element">

                        <!-- Editable: own agency + selected row -->
                        <dw-dropdown
                        *ngIf="
                            editSelfCollaborateResponses &&
                            selectedRecord?.agencyId === myAgencyId &&
                            selectedRecord?.id === element.id
                        "
                        [selectedItem]="element.plannedCommitted"
                        [dataSource]="givingOptionsList"
                        (change)="doStatusChange(selectedRecord.id, element)"
                        (itemSelected)="element.plannedCommitted = $event;
                                        doStatusChange(selectedRecord.id, element)">
                        </dw-dropdown>

                        <!-- Read-only: own agency but NOT selected -->
                        <span
                        *ngIf="
                            selectedRecord?.agencyId === myAgencyId &&
                            selectedRecord?.id !== element.id
                        "
                        [ngStyle]="{ color: showCommitmentColors(element.plannedCommitted) }"
                        style="padding-left: 3px;">
                        {{ element.plannedCommitted }}
                        </span>

                        <!-- Read-only: other agencies (only if viewing is allowed) -->
                        <span
                        *ngIf="
                            viewOtherCollaborateResponsesSecondary &&
                            selectedRecord?.agencyId !== myAgencyId
                        "
                        [ngStyle]="{ color: showCommitmentColors(element.plannedCommitted) }"
                        style="padding-left: 3px;">
                        {{ element.plannedCommitted }}
                        </span>

                    </td>
                    </ng-container>

            <!-- Response date -->
            <ng-container matColumnDef="responseDate" >
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local"
                    style="min-width: 100px;">Response Date
                </th>
                <td mat-cell style="width:100px!important;"
                    class="table-detail-style-local"
                    *matCellDef="let element">{{element.responseDate | date:'mediumDate':'EST'}}</td>
            </ng-container>

            <!-- delete -->
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef class="mat-table-header-style mat-table-header-override"></th>
                <td mat-cell *matCellDef="let element"
                    style="padding-left: 1px;padding-right: 6px;width:6px;" class="table-row-class">
                    <!-- Primary agency deleting other agency's response -->
                    <a (click)="deleteResponse(element)" matTooltipPosition="right"
                       *ngIf="primaryAgencyFlag && deleteAnyCollaborateResponses"
                       matTooltip="Delete record"> <mat-icon class="control-icon-style">delete</mat-icon></a>
                    
                    <!-- Any agency deleting their own response -->
                    <a (click)="deleteResponse(element)" matTooltipPosition="right"
                       *ngIf="element.agencyId === myAgencyId && deleteSelfCollaborateResponses"
                       matTooltip="Delete record"> <mat-icon class="control-icon-style">delete</mat-icon></a></td>
            </ng-container>

            <!-- Amount -->
           <ng-container matColumnDef="amount" *ngIf="primaryAgencyFlag">
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local"
                    style="width:80px;">
                    Amount
                </th>

                <td mat-cell
                    class="mat-table-detail-style"
                    *matCellDef="let element">

                    <!-- Self agency: editable (selected row only) -->
                    <input
                    *ngIf="
                        editSelfCollaborateResponses &&
                        selectedRecord?.agencyId === myAgencyId &&
                        selectedRecord?.id === element.id &&
                        selectedRecord?.plannedCommitted !== 'Denied'
                    "
                    matInput
                    type="number"
                    min="1"
                    class="table-detail-style-local"
                    style="width:80px!important; border:.5px solid gray"
                    [(ngModel)]="element.amountProvided"
                    (change)="doAmountChange($event, element)"
                    />

                    <!-- Other agency: editable only if allowed -->
                    <input
                    *ngIf="
                        editOtherCollaborateResponses &&
                        selectedRecord?.agencyId !== myAgencyId &&
                        selectedRecord?.id === element.id &&
                        selectedRecord?.plannedCommitted !== 'Denied'
                    "
                    matInput
                    type="number"
                    min="1"
                    class="table-detail-style-local"
                    style="width:80px!important; border:.5px solid gray"
                    [(ngModel)]="element.amountProvided"
                    (change)="doAmountChange($event, element)"
                    />

                    <!-- Read-only: selected row but not editable -->
                    <span
                    *ngIf="
                        selectedRecord?.id === element.id &&
                        selectedRecord?.plannedCommitted === 'Denied'
                    "
                    class="table-detail-style-local"
                    style="width:80px!important">
                    {{ element.amountProvided }}
                    </span>

                    <!-- Read-only: non-selected rows -->
                    <span
                    *ngIf="selectedRecord?.id !== element.id"
                    class="table-detail-style-local"
                    style="width:80px!important">
                    {{ element.amountProvided }}
                    </span>

                </td>
                </ng-container>
                 <ng-container matColumnDef="amount" *ngIf="!primaryAgencyFlag">
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local"
                    style="width:80px;">
                    Amount
                </th>

                <td mat-cell
                    class="mat-table-detail-style"
                    *matCellDef="let element">

                    <!-- Self agency: editable (selected row only) -->
                    <input
                    *ngIf="
                        editSelfCollaborateResponses &&
                        selectedRecord?.agencyId === myAgencyId &&
                        selectedRecord?.id === element.id &&
                        selectedRecord?.plannedCommitted !== 'Denied'
                    "
                    matInput
                    type="number"
                    min="1"
                    class="table-detail-style-local"
                    style="width:80px!important; border:.5px solid gray"
                    [(ngModel)]="element.amountProvided"
                    (change)="doAmountChange($event, element)"
                    />

                    <!-- Other agency: editable only if allowed -->
                    <input
                    *ngIf="
                        editOtherCollaborateResponses &&
                        selectedRecord?.agencyId !== myAgencyId &&
                        selectedRecord?.id === element.id &&
                        selectedRecord?.plannedCommitted !== 'Denied'
                    "
                    matInput
                    type="number"
                    min="1"
                    class="table-detail-style-local"
                    style="width:80px!important; border:.5px solid gray"
                    [(ngModel)]="element.amountProvided"
                    (change)="doAmountChange($event, element)"
                    />

                    <!-- Read-only: selected row but not editable -->
                    <span
                    *ngIf="
                        selectedRecord?.id === element.id &&
                        selectedRecord?.plannedCommitted === 'Denied'
                    "
                    class="table-detail-style-local"
                    style="width:80px!important">
                    {{ element.amountProvided }}
                    </span>

                    <!-- Read-only: non-selected rows -->
                    <span
                    *ngIf="selectedRecord?.id !== element.id"
                    class="table-detail-style-local"
                    style="width:80px!important">
                    {{ element.amountProvided }}
                    </span>

                </td>
                </ng-container>


            <!-- Unit of Measure -->
            <ng-container matColumnDef="unitOfMeasure" >
                <th mat-header-cell *matHeaderCellDef
                    class="table-header-style-local"
                    style="min-width: 100px;">UOM
                </th>
                <td mat-cell
                    class="table-detail-style-local"
                    style="padding-left: 5px; width:100px!important;"
                    *matCellDef="let element">{{element.unitOfMeasure}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)">
            </tr>
        </table>
        <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
    </div>
    <!-- END CONTRIBUTIONS TABLE -->

    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->
    <div class="error-line" [hidden]='!strErr.length'
         style="text-align:left; bottom:54px; left: 15px;">{{strErr}}</div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div style="text-align:center; margin-top: 30px;">
        <button class="command-button"
                style="width:130px"
                [disabled]="(!enableSubmit && !closeRequest) && !editSelfCollaborateResponses && !editOtherCollaborateResponses"
                (click)="onSubmitClicked(false)"
                matTooltipPosition="above"
                matTooltip="Save the details without approving"
                mat-button>
            <mat-icon>save</mat-icon>
            Save
        </button>
        <button class="command-button"
                style="width:130px"
                [disabled]="!enableSubmit && !closeRequest"
                *ngIf="visibleFinalize"
                (click)="onSubmitClicked(true)"
                matTooltipPosition="above"
                matTooltip="Finalize (approve/close) this request across all agencies"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Finalize
        </button>
        <button class="command-button" style="width:130px"
                (click)="onCancelClicked()"
                matTooltipPosition="above"
                matTooltip="Close the approve window" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>
</div>

<p-dialog header="Collaboration Request" [focusOnShow]="false"
          [(visible)]="addCollaborationDlg" [modal]="true"
          [style]="{width: '650px', height: '605px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-collaborate-req #collaborateReq
                         [serviceRequest]="serviceRequest"
                         (cancelClicked)="addCollaborationDlg=false"
                         (submitClicked)="doCollaborateSubmitted($event)">
    </app-collaborate-req>
</p-dialog>

<p-dialog header="Reclose Request" [focusOnShow]="false"
          [(visible)]="displayRecloseDlg" [modal]="true"
          [style]="{width: '450px', height: '290px'}"
          appendTo="body" [closeOnEscape]="false"
          [resizable]="false" [closable]="true" >
    <app-reclose-dialog #reclosedlg
          (submitClicked)="submitFromRecloseDialog($event);"
          (cancelClicked)="cancelFromRecloseDialog($event);"></app-reclose-dialog>
</p-dialog>